/*
 * Returns the URL to the api
 */
const getApiUrl = (): string => process.env.REACT_APP_PAYTHEM_PAYER_API_URL || "";
export default getApiUrl;
